import { el, setAttr } from 'redom';

import { getQuotedMessageSenderName, getQuotedMessageText } from '../../utilities/quoted-message';

class QuotedMessagePreview {

  constructor(configuration) {

    this.onClear = configuration.onClear;

    this.senderDisplay = el('span.quoted-message-preview-sender');
    this.textDisplay = el('span.quoted-message-preview-text');

    this.el = el('#quoted-message-preview-main', [
      el('.quoted-message-preview-content', [this.senderDisplay, this.textDisplay]),
      el('button.quoted-message-preview-close-button', {
        type: 'button',
        title: 'Remove quote',
        onclick: this.handleClearClick.bind(this)
      }, '×')
    ]);

    this.hide();

  }

  handleClearClick(event) {

    event.preventDefault();
    event.stopPropagation();

    this.onClear();

  }

  hide() {

    setAttr(this.el, { style: { display: 'none' } });

  }

  update(quotedMessage) {

    if (quotedMessage === void 0 || quotedMessage === null) {
      this.hide();
      return;
    }

    this.senderDisplay.textContent = getQuotedMessageSenderName(quotedMessage);
    this.textDisplay.textContent = getQuotedMessageText(quotedMessage);

    setAttr(this.el, { style: { display: 'flex' } });

  }

}

export default QuotedMessagePreview;
